import apiCallWrapper from 'utils/apiCallWrapper';
import * as constants from './constants';

const middleware: any = ({
  dispatch,
  getState,
}: {
  dispatch: any;
  getState: any;
}) => (next: any) => (action: any) => {
  // eslint-disable-next-line default-case
  switch (action.type) {
    case constants.TABLE_ON_DATA_FETCH:
      apiCallWrapper({
        ...action.payload,
        dispatch,
      });
      break;
    default:
      break;
  }

  return next(action);
};

export default middleware;
